import { Link, useLocation, matchPath } from "react-router-dom";
import Paths from "router/Paths";
import { useEffect, useMemo } from "react";
import { useDocTypeContext } from "context/DocTypeContext"
import { useSearchParams } from "react-router-dom";

import { HomeSvg, AngleRightSvg } from "svg/icons";
import "./breadcrumbs.scss";

const param_routes = [
   Paths.Documents.List()
];

const titles = {
   [ Paths.Home ]: "Witaj w aplikacji!",
   [ Paths.TerritorialUnits ]: "Jednostki terytorialne",
   [ Paths.DocumentTypes ]: "Rodzaje dokumentów",
   [ Paths.Documents.Start ]: "Wyniki wyszukiwania",
   [ Paths.Documents.List()]: "Wyniki wyszukiwania",
   [ Paths.MessageTemplates ]: "Wzory wiadomości",
   [ Paths.CorrespondenceWithUnits ]: "Korespondencja z jednostkami terytorialnymi",
   [ Paths.FileArchives ]: "Paczki plików",
   [ Paths.Users ]: "Lista użytkowników",
   [ Paths.Analysis ]: "Analiza"
}

export default function Breadcrumbs() {

   const [ search_params ] = useSearchParams();
   const { doc_types } = useDocTypeContext();
   const doc_type_id = search_params.get( "document_type_id" );

   const pathname = useLocation().pathname;
   const pattern = param_routes.find( route => matchPath( route, pathname ));

   const page_title = useMemo(() => {

      let page_title = titles[ pattern || pathname ]; 

      if ( pathname !== Paths.Analysis ) {
         return page_title; 
      }

      if ( !doc_type_id ) return page_title;

      const doc_type_name = doc_types.find( d => d.id === +doc_type_id )?.name;
      if ( !doc_type_name ) return page_title;

      return page_title + ": " + doc_type_name;
   }, [ doc_type_id, pathname, pattern ]);

   return (
      <div className="breadcrumbs">
         <h1> { page_title } </h1>

         <div className="breadcrumbs-items">
            <Link to={ Paths.Home }>
               <HomeSvg/> <span> Home </span>
            </Link>

            { pathname === Paths.Analysis && 
               <>
                  <AngleRightSvg stroke="#007042"/>
                  <Link to={ Paths.Documents.List( doc_type_id || "all" )}> Wyniki wyszukiwania </Link>
               </>
            }

            { pathname !== Paths.Home &&
               <>
                  <AngleRightSvg stroke="#007042"/>

                  <div>
                     <span> { page_title } </span>
                  </div>
               </>
            }
            
         </div>
      </div>
   )
}
